var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-3d853c09-20eb-4fb9-b156-1b30ddee061e",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-1ad24026-a120-4f2f-8daa-05a2636013ef {\r\n        fill: #2c2c2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1ad24026-a120-4f2f-8daa-05a2636013ef",
    d: "M1248,96c52.93,0,96,43.06,96,96v1536c0,52.94-43.07,96-96,96H192c-52.93,0-96-43.06-96-96V192c0-52.94,43.07-96,96-96h1056M1248,0H192C85.96,0,0,85.96,0,192v1536c0,106.04,85.96,192,192,192h1056c106.04,0,192-85.96,192-192V192c0-106.04-85.96-192-192-192h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-1ad24026-a120-4f2f-8daa-05a2636013ef",
    points: "992.62 639.84 832.31 639.84 717.14 828 597.14 639.84 419.53 639.84 630.7 950.91 414.7 1280.16 574.08 1280.16 708.47 1065.09 846.7 1280.16 1025.3 1280.16 794.86 941.25 992.62 639.84 992.62 639.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.f97cd367e2d0b780bf84ec3c73f654eb.svg";
export { ForwardRef as ReactComponent };